import React, { useContext} from "react";
import Select from 'react-select';
import { ProductsContext } from "../context/products.context";


const OptionsOutsideSelect = (props) => {
  const { selectedOption, setSelectedOption, selectedSchools, setSelectedSchools, listSchools} = useContext(ProductsContext)
  const { isMulti } = props;
  const optionsEthnicity = [
    {label: "Ethnicity / Race",
    options:
  [
    {value:"American Indian/Alaskan Native", label:"American Indian/Alaskan Native"},
    {value:"Asian", label:"Asian"},
    {value:"Black/African American", label:"Black/African American"},
    {value:"Hispanic/Latino", label:"Hispanic/Latino"},
    {value:"Native Hawaiian/Other Pacific Islander", label:"Native Hawaiian/Other Pacific Islander"},
    {value:"Two or More Races", label:"Two or More Races"},
    {value:"White", label:"White"},
  ]},{
  label: "Gender",
  options:
  [
    {value:"Female", label:"Female"},
    {value:"Male", label:"Male"},
    {value:"X", label:"X"}
  ]},
  {
    label: "Program & Characteristic",
    options:
    [
      {value:"Economically Disadvantaged", label:"Economically Disadvantaged"},
      {value:"English Learners", label:"English Learners"},
      {value:"Homeless", label:"Homeless"},
      {value:"Migrant", label:"Migrant"},
      {value:"Military Parent", label:"Military Parent"},
      {value:"Section504", label:"Section504"},
      {value:"Students w/ Disabilities", label:"Students w/ Disabilities"},

    ]},


  ];

  // ["American Indian/Alaskan Native",
  // "Asian",
  // "Black/African American",
  // "Hispanic/Latino",
  // "Native Hawaiian/Other Pacific Islander",
  // "Two or More Races",
  // "White"]

  const optionsSpecialGroups = [



    {value:"Economically Disadvantaged", label:"Economically Disadvantaged"},
    {value:"English Learners", label:"English Learners"},
    {value:"Homeless", label:"Homeless"},
    {value:"Migrant", label:"Migrant"},
    {value:"Military Parent", label:"Military Parent"},
    {value:"Section504", label:"Section504"},
    {value:"Students w/ Disabilities", label:"Students w/ Disabilities"},





  ];

  // ["Economically Disadvantaged",
  // "English Learners",
  // "Female",
  // "Male",
  // "Homeless",
  // "Migrant",
  // "Military Parent",
  // "Section504",
  // "Students w/ Disabilities",
  // "X"]





//   const DropdownIndicator = (
//     props: DropdownIndicatorProps<ColourOption, true>
//   ) => {
//     return (
//       <components.DropdownIndicator {...props}>
//         <EmojiIcon label="Emoji" primaryColor={colourOptions[2].color} />
//       </components.DropdownIndicator>
//     );
//   };
const menuPortalTarget = document.getElementById('root');
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: '#ffffff',
      // outline: '1px solid #dcdcdc',

      cursor:'pointer',
      '&:hover': {
        borderColor: '#818cf8',
      },

    //   background: '#4a499f',
      // borderColor: '#c4c4c4',
      // borderWidth: "1px",
      minHeight: '60px',
      height: '60px',
      outline: 'none',

      boxShadow: state.isFocused ? null : null,
    }),


    input: (provided, state) => ({
      ...provided,
      marginLeft: '30px',


    }),
  };


  const handleRemoveSchool = (e) => {
    if (!setSelectedSchools) return;
    const { name: buttonName } = e.currentTarget;
    const removedValue = selectedSchools.find((val) => val.value === buttonName);
    if (!removedValue) return;
    setSelectedSchools(
      selectedSchools.filter((val) => val.value !== buttonName),
      { action: "remove-value", removedValue }
    );
  };

  const handleRemoveStudentGroup = (e) => {
    if (!setSelectedOption) return;
    const { name: buttonName } = e.currentTarget;
    const removedValue = selectedOption.find((val) => val.value === buttonName);
    if (!removedValue) return;
    setSelectedOption(
      selectedOption.filter((val) => val.value !== buttonName),
      { action: "remove-value", removedValue }
    );
  };

  return (
    <div >

<div className="flex flex-row border-b-2 border-gray-200 pb-8 pt-6">
      <Select className='ml-4 min-w-[310px]' {...props} controlShouldRenderValue={!isMulti}

maxMenuHeight={800}

components={{ DropdownIndicator:() => (
  <div className="pr-2 text-gray-400"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
  <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9" />
</svg>
</div>
), IndicatorSeparator:() => null }}
options={listSchools.map((e) => (

  {value: e, label: e}))
}
  onChange={setSelectedSchools}
  value={selectedSchools}
      styles={customStyles}
      isClearable={false}
      placeholder={
        <div className='flex flex-row items-center text-gray-700'><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-11.25a.75.75 0 00-1.5 0v2.5h-2.5a.75.75 0 000 1.5h2.5v2.5a.75.75 0 001.5 0v-2.5h2.5a.75.75 0 000-1.5h-2.5v-2.5z" clipRule="evenodd" />
      </svg>
      <span className='pl-2 w-[245px]'>Add School to view</span>
      </div>

      }

       />{!selectedSchools.length > 0 &&
        <div className="rounded-r-lg w-[200px] h-15  bg-amber-100 items-center flex animate-pulse"><div className="-ml-3 h-0 w-0 border-y-8 border-y-transparent border-r-[12px] border-r-amber-100"></div><div className="pl-2 flex flex-row gap-2 text-amber-600 font-semibold"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-12 h-12">
   <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
 </svg>
  selection needed to populate view</div></div>} {selectedSchools.length > 0 &&
        <div className="pl-6 -mt-6">
        <span className="font-xs text-gray-400 ">Schools currently selected:</span>
        <div className='flex text-sm flex-wrap items-center'>

         {isMulti
           ? selectedSchools.map((val) => (
               <button

               name={val.value} onClick={handleRemoveSchool}
               className=" hover:text-blue-700 group p-2 px-4 m-1 font-light bg-blue-100/60 text-black select-none rounded-md"
               key={val.value}>
                 {val.label}
                 <span
                 className=" text-black cursor-pointer pl-3 font-bold group-hover:text-blue-700"
                 >
                   ✕
                 </span>
               </button>
             ))
           : null}       <button
           onClick={() => setSelectedSchools([])}

           className="text-blue-500 no-underline hover:underline p-2 m-1 text-xs">CLEAR ALL
           </button> </div>
       </div>}
       </div>


       <div className="flex flex-row pb-5 pt-8">




      <Select className='ml-4 min-w-[310px]'  {...props} controlShouldRenderValue={!isMulti}


maxMenuHeight={800}

components={{ DropdownIndicator:() => (
  <div className="pr-2 text-gray-400"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
  <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9" />
</svg>
</div>
), IndicatorSeparator:() => null }}
onChange={setSelectedOption}
options={optionsEthnicity}
value={selectedOption}
      styles={customStyles}
      isClearable={false}
      placeholder={
        <div className='flex flex-row items-center text-gray-700'><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-11.25a.75.75 0 00-1.5 0v2.5h-2.5a.75.75 0 000 1.5h2.5v2.5a.75.75 0 001.5 0v-2.5h2.5a.75.75 0 000-1.5h-2.5v-2.5z" clipRule="evenodd" />
      </svg>
      <span className='pl-2  w-[245px]'>Add student group to view</span>
      </div>}

       />
{!selectedOption.length > 0 &&
       <div className="rounded-r-lg w-[200px] h-15  bg-amber-100 items-center flex animate-pulse"><div className="-ml-3 h-0 w-0 border-y-8 border-y-transparent border-r-[12px] border-r-amber-100"></div><div className="pl-2 flex flex-row gap-2 text-amber-600 font-semibold"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-12 h-12">
  <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
</svg>
 selection needed to populate view</div></div>}
        {selectedOption.length > 0 &&
        <div className="pl-6 -mt-6 ">
        <span className="font-xs text-gray-400 ">Student groups currently selected:</span>
        <div className='flex text-sm flex-wrap items-center'>

         {isMulti
           ? selectedOption.map((val) => (
               <button
               name={val.value} onClick={handleRemoveStudentGroup}
               className=" hover:text-blue-700 group p-2 px-4 m-1 font-light bg-blue-100/60 text-black select-none rounded-md"
               key={val.value}>
                 {val.label}
                 <span
                 className=" text-black cursor-pointer pl-3 font-bold group-hover:text-blue-700"
                 >
                   ✕
                 </span>
               </button>
             ))
           : null}       <button
           onClick={() => setSelectedOption([])}

           className="text-blue-500 no-underline hover:underline p-2 m-1 text-xs">CLEAR ALL
           </button> </div>
       </div>}</div>



       </div>







  );
};


// <button
// onClick={() => setSelectedOption([])}
// disabled={!value.length > 0}
// className={`${value.length > 0 ? "text-blue-500 no-underline hover:underline" : "no-underline text-gray-400"}  px-[6px] text-xs`}>CLEAR ALL
// </button>

export default OptionsOutsideSelect;
